import axios from "axios";

const CLOUD_NAME = "wntihqq9";
const UPLOAD_PRESET = "blog_upload";

export const uploadImage = async (file) => {
    try {
        console.log("Uploading...", file);

        const formData = new FormData();

        formData.append("file", file);
        formData.append("upload_preset", UPLOAD_PRESET);

        const response = await axios.post(
            `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`,
            formData
        );

        console.log("✅ Image uploaded:", response.data.secure_url);

        return response.data.secure_url;

    } catch (error) {
        console.error("❌ Cloudinary upload failed:", error);

        throw error;
    }
};

console.log("✅ Cloudinary Service Loaded");